import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

const SKIP_HOOK_URL = "https://hook.eu1.make.com/a9fqigx4f7te8m54qxrxc0putswgn7jt";
const SF_LEAD_URL = `${process.env.REACT_APP_BE_BASE_URL}salesforce/lead`;

const RadioInfo = () => {
    const location = useLocation();
    const { email, phoneNumber, fullName, } = location.state || {};
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams();
      useEffect(()=>{    
        if (!email && !searchParams.get("skip")) {
          navigate('/register?step=1')
        }
      },[])
  const [values, setValues] = useState({
    smoking: 'לא',
    chronicDisease: 'לא',
    medicalExam: 'לא',
  });
  
  const handleQuestionsSubmit = () => {
    axios.post(`${process.env.REACT_APP_BE_BASE_URL}user/register?step=4`,
      {
        email:email || undefined,
        do_you_smoke: values.smoking,
        chronic_illness: values.chronicDisease,
        medical_examination: values.medicalExam,
      }
    ).then((res)=>{
      toast.success("Details submitted successfully!");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "lead_form_submit",
        form_name: "register_step_4_lead_form",
        form_id: `register_step_4_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        page_url: window.location.href,
      });
      console.log("GTM lead_form_submit event fired for register step 4");
      const nameParts4 = (fullName || "").trim().split(/\s+/);
      const sfPayload4 = {
        ProFin__First_Name__c: nameParts4.slice(0, -1).join(" ") || nameParts4[0] || "",
        ProFin__Last_Name__c: nameParts4.length > 1 ? nameParts4[nameParts4.length - 1] : nameParts4[0] || "",
        ProFin__Email__c: email,
        ProFin__Mobile_Phone__c: phoneNumber,
        ProFin__Status__c: "Fourth Step Completed",
        ProFin__Source__c: "Web",
        Source_App__c: "Web App",
      };
      const logSfCall4 = (logs) => {
        axios.post(`${process.env.REACT_APP_BE_BASE_URL}api-log/save`, { logs }).catch(() => {});
      };
      const sfRecordId4 = localStorage.getItem(`sf_lead_id_${email}`);
      if (sfRecordId4) sfPayload4._sfRecordId = sfRecordId4;
      axios.post(SF_LEAD_URL, sfPayload4)
        .then((r) => {
          if (r.data?.id) localStorage.setItem(`sf_lead_id_${email}`, r.data.id);
          console.log("SF Lead Step 4:", r.status);
          logSfCall4([{
            email, full_name: fullName, phone_number: phoneNumber,
            page: "RadioInfo", registration_step: "step_4",
            api_name: "salesforce_lead_direct", api_url: SF_LEAD_URL,
            was_called: true, skip_reason: null,
            request_payload: sfPayload4,
            response_status: r.status, response_settled: "fulfilled",
            response_data: r.data || null, error_message: null,
          }]);
        })
        .catch((e) => {
          console.error("SF Lead Step 4 failed:", e?.message);
          logSfCall4([{
            email, full_name: fullName, phone_number: phoneNumber,
            page: "RadioInfo", registration_step: "step_4",
            api_name: "salesforce_lead_direct", api_url: SF_LEAD_URL,
            was_called: true, skip_reason: null,
            request_payload: sfPayload4,
            response_status: e?.status || null, response_settled: "rejected",
            response_data: e?.response?.data || null, error_message: e?.message || null,
          }]);
        });
      navigate('/register?step=4', { state: { email, phoneNumber, fullName, idNumber: location?.state?.idNumber, birthDate: location?.state?.birthDate, issueDate: location?.state?.issueDate } });
    }).catch((err)=>{
      toast.error("Unable to save details, please try again!");
    })
  }

  const handleChange = (event, question) => {
    setValues((prevValues) => ({
      ...prevValues,
      [question]: event.target.value,
    }));
  };
  
  return (
    <div className='form_box'>
      <h2 className="box_head">הגיע הזמן לעשות סדר <br/>בפנסיה ובביטוחים שלך</h2>

        <div className='radio_outer'>
          <FormControl style={{ marginBottom: '20px' }}>
            <label className="radio_label">האם אתה מעשן?</label>
            <RadioGroup
              aria-labelledby="smoking-radio-buttons-group"
              name="smoking-radio-buttons-group"
              value={values.smoking}
              onChange={(event) => handleChange(event, 'smoking')}
            >
              <div className='radio_grp'>
                <FormControlLabel
                  style={{ marginRight: '0px' }}
                  className='radio_con'
                  value="כן"
                  control={<Radio className='radio_round' />}
                  label="כן"
                />
                <FormControlLabel
                  style={{ marginRight: '0px' }}
                  className='radio_con'
                  value="לא"
                  control={<Radio className='radio_round' />}
                  label="לא"
                />
              </div>
            </RadioGroup>
          </FormControl>

          <FormControl style={{ marginBottom: '20px' }}>
            <label className="radio_label">האם יש לך מחלה כרונית?</label>
            <RadioGroup
              aria-labelledby="chronic-disease-radio-buttons-group"
              name="chronic-disease-radio-buttons-group"
              value={values.chronicDisease}
              onChange={(event) => handleChange(event, 'chronicDisease')}
            >
              <div className='radio_grp'>
                <FormControlLabel
                  style={{ marginRight: '0px' }}
                  className='radio_con'
                  value="כן"
                  control={<Radio className='radio_round' />}
                  label="כן"
                />
                <FormControlLabel
                  style={{ marginRight: '0px' }}
                  className='radio_con'
                  value="לא"
                  control={<Radio className='radio_round' />}
                  label="לא"
                />
              </div>
            </RadioGroup>
          </FormControl>
          <FormControl>
            <label className="radio_label">האם אתה בתהליך של בדיקה רפואית?</label>
            <RadioGroup
              aria-labelledby="medical-exam-radio-buttons-group"
              name="medical-exam-radio-buttons-group"
              value={values.medicalExam}
              onChange={(event) => handleChange(event, 'medicalExam')}
            >
              <div className='radio_grp'>
                <FormControlLabel
                  style={{ marginRight: '0px' }}
                  className='radio_con'
                  value="כן"
                  control={<Radio className='radio_round' />}
                  label="כן"
                />
                <FormControlLabel
                  style={{ marginRight: '0px' }}
                  className='radio_con'
                  value="לא"
                  control={<Radio className='radio_round' />}
                  label="לא"
                />
              </div>
            </RadioGroup>
          </FormControl>
        </div>
        <button className='login_btn' onClick={handleQuestionsSubmit}>שלב הבא</button>
        {/* <Link to="/register?step=4&skip=true" className='quit_link'>לדלג</Link> */}
        <div className='text-center' onClick={() => {
          axios.post(SKIP_HOOK_URL, {
            skipped_step: 3,
            full_name: fullName,
            email,
            phone_number: phoneNumber,
            idNumber: location?.state?.idNumber,
            birthDate: location?.state?.birthDate,
            issueDate: location?.state?.issueDate,
          }).catch(() => {});
          navigate('/register?step=4&skip=true', { state: { email, phoneNumber, fullName, idNumber: location?.state?.idNumber, birthDate: location?.state?.birthDate, issueDate: location?.state?.issueDate }});
        }}>
        <span className='link_btn'>
        לדלג
        </span>
      </div>
    </div>
  );
};

export default RadioInfo;
